export default __webpack_public_path__ + "static/media/03.78be76cd.svg";